/**
 * Cut for specifying filters on event data attribute.
 */
var Cut = /** @class */ (function () {
    /**
     * Create the cut to filter an event data attribute.
     * @param field Name of the event data attribute to be filtered.
     * @param minValue Minimum allowed value of the event data attribute.
     * @param maxValue Maximum allowed value of the event data attribute.
     */
    function Cut(field, minValue, maxValue) {
        this.field = field;
        this.minValue = minValue;
        this.maxValue = maxValue;
    }
    return Cut;
}());
export { Cut };
//# sourceMappingURL=cut.model.js.map